import { render, staticRenderFns } from "./MockPlayer.vue?vue&type=template&id=142c19fd&scoped=true&"
import script from "./MockPlayer.vue?vue&type=script&lang=js&"
export * from "./MockPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142c19fd",
  null
  
)

export default component.exports